module.exports = __webpack_public_path__ + "img/12.33d77d41.jpg";